import { Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Currency, MetricConversionRate, Metrics, MetricsFacade } from '@app/shared/+state/metrics';
import { LoadingState, User } from '@app/shared/interfaces';
import { ConvertEnumToArray } from '@app/shared/utils';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss', './metrics.component.mobile.scss'],
  providers: [MetricsFacade],
})
export class MetricsComponent implements OnInit {
  pageLoadingState$: Observable<LoadingState | null>;
  user: User;
  currencies$: Observable<Currency[] | null>;
  defaultCurrency$: Observable<string | null>;
  conversionRates$: Observable<MetricConversionRate[] | null>;

  LoadingState = LoadingState;
  Metrics = Metrics;
  tabs = ConvertEnumToArray<Metrics[]>(Metrics);
  activeTab: Metrics = Metrics.Reservations;
  constructor(
    private authService: AuthenticationService,
    private metricsFacade: MetricsFacade,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pageLoadingState$ = this.metricsFacade.currenciesLoadingState$;
    this.user = this.authService.getUserDetails();
    this.currencies$ = this.metricsFacade.currencies$;
    this.defaultCurrency$ = this.metricsFacade.defaultCurrency$;
    this.conversionRates$ = this.metricsFacade.conversionRates$;

    this.metricsFacade.loadCurrencies();

    this.route.queryParams.subscribe((params) => {
      this.activeTab = params['tab'] || Metrics.Reservations;
    });
  }

  changeDefaultCurrency(change: MatSelectChange) {
    const { value } = change;

    if (value) {
      this.metricsFacade.updateDefaultCurrency(
        {
          currency: value,
        },
        this.activeTab
      );
    }
  }

  changeTab(tab: Metrics) {
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tab },
      queryParamsHandling: 'merge',
    });
  }
}
